import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { StateProvider } from "./StateProvider";
import reducer, { intialState } from "./reducer";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <StateProvider intialState={intialState} reducer={reducer}>
        <BrowserRouter>

          <App />

        </BrowserRouter>
      </StateProvider>
    </HelmetProvider>
  </React.StrictMode>
);

